import { render, staticRenderFns } from "./ShopShow.vue?vue&type=template&id=0220d845&scoped=true&"
import script from "./ShopShow.vue?vue&type=script&lang=js&"
export * from "./ShopShow.vue?vue&type=script&lang=js&"
import style0 from "./ShopShow.vue?vue&type=style&index=0&id=0220d845&prod&scoped=true&lang=css&"
import style1 from "./ShopShow.vue?vue&type=style&index=1&id=0220d845&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0220d845",
  null
  
)

export default component.exports